module.exports = "<div><div><strong>Image</strong></div><div><label>Entity Field: <input name=placeholderinput type=text ng-model=\"selectedPdfElements[0].placeHolder\"></label></div></div>";
